// types
import { createSlice, createAsyncThunk } from '@reduxjs/toolkit';
import { API } from 'aws-amplify';

const initialState = require('../initialState').dashboardInitialState;

export const loadStores = createAsyncThunk('dashboard/loadStores', (token) => {
    console.log('loading stores');

    return API.get('EFWAPI', '/app/stores', {
        headers: {
            Authorization: `Bearer ${token}`,
            'Content-Type': 'application/json'
        }
    });
});

export const loadSuppliers = createAsyncThunk('dashboard/loadSuppliers', (token) => {
    console.log('loading suppliers');

    return API.get('EFWAPI', '/app/suppliers?fieldset=forSelect', {
        headers: {
            Authorization: `Bearer ${token}`,
            'Content-Type': 'application/json'
        }
    });
});

export const loadBrands = createAsyncThunk('dashboard/loadBrands', (token) => {
    console.log('loading brands');

    return API.get('EFWAPI', '/app/brands?fieldset=forSelect', {
        headers: {
            Authorization: `Bearer ${token}`,
            'Content-Type': 'application/json'
        }
    });
});

export const loadSalesStats = createAsyncThunk('dashboard/loadSalesStats', (data) => {
    const { token, store_filter } = data;

    console.log('loading sales stats', store_filter);

    return API.post('EFWAPI', '/app/dashboard/sales-stats', {
        body: {
            store_filter
        },
        headers: {
            Authorization: `Bearer ${token}`,
            'Content-Type': 'application/json'
        }
    });
});

export const loadAccountPayableChart = createAsyncThunk('dashboard/loadAccountPayableChart', (data) => {
    const { token, store_filter, period } = data;

    console.log('loading account payable chart', store_filter);

    return API.post('EFWAPI', '/app/dashboard/account-payable-chart', {
        body: {
            store_filter,
            period
        },
        headers: {
            Authorization: `Bearer ${token}`,
            'Content-Type': 'application/json'
        }
    });
});

export const loadBestSellers = createAsyncThunk('dashboard/loadBestSellers', (data) => {
    const { token, store_filter, period, order } = data;

    console.log('loading best sellers', store_filter);

    return API.post('EFWAPI', '/app/dashboard/best-sellers', {
        body: {
            store_filter,
            period,
            order
        },
        headers: {
            Authorization: `Bearer ${token}`,
            'Content-Type': 'application/json'
        }
    });
});

export const loadProductClasses = createAsyncThunk('dashboard/loadProductClasses', (token) => {
    console.log('loading product classes');

    return API.get('EFWAPI', '/app/products/class', {
        headers: {
            Authorization: `Bearer ${token}`,
            'Content-Type': 'application/json'
        }
    });
});

export const loadCategories = createAsyncThunk('dashboard/loadCategories', (token) => {
    console.log('loading categories');

    return API.get('EFWAPI', '/app/categories', {
        headers: {
            Authorization: `Bearer ${token}`
        }
    });
});

const dashboard = createSlice({
    name: 'dashboard',
    initialState,
    reducers: {
        setLoading: (state, action) => {
            state.loading = action.payload;
        },
        setStoreFilter: (state, action) => {
            state.filters.store = action.payload;
        },
        setSupplierFilter: (state, action) => {
            state.filters.supplier = action.payload;
        },
        reset: () => {
            return initialState;
        }
    },
    extraReducers: (builder) => {
        //loadStores
        builder.addCase(loadStores.pending, (state) => {
            state.stores.loading = true;
        });
        builder.addCase(loadStores.fulfilled, (state, action) => {
            const response = action.payload;
            if (response?.success) {
                state.stores.data = response.data.stores;
                state.stores.active_only = response.data.stores.filter((store) => store.status === 'active');
            } else {
                state.stores.error = response?.error;
            }
            state.stores.loading = false;
        });
        builder.addCase(loadStores.rejected, (state, err) => {
            console.log(err);
            state.stores.loading = false;
        });

        //loadSuppliers
        builder.addCase(loadSuppliers.pending, (state) => {
            state.suppliers.loading = true;
        });
        builder.addCase(loadSuppliers.fulfilled, (state, action) => {
            const response = action.payload;
            if (response?.success) {
                state.suppliers.data = response.data.suppliers;
            } else {
                state.suppliers.error = response?.error;
            }
            state.suppliers.loading = false;
        });
        builder.addCase(loadSuppliers.rejected, (state, err) => {
            console.log(err);
            state.suppliers.loading = false;
        });

        // loadProductClasses
        builder.addCase(loadProductClasses.pending, (state) => {
            state.productClasses.loading = true;
        });
        builder.addCase(loadProductClasses.fulfilled, (state, action) => {
            const response = action.payload;
            if (response?.success) {
                state.productClasses.data = response.data.product_classes;
            } else {
                state.productClasses.error = response?.error;
            }
            state.productClasses.loading = false;
        });
        builder.addCase(loadProductClasses.rejected, (state, err) => {
            console.log(err);
            state.productClasses.loading = false;
        });

        //loadBrands
        builder.addCase(loadBrands.pending, (state) => {
            state.brands.loading = true;
        });
        builder.addCase(loadBrands.fulfilled, (state, action) => {
            const response = action.payload;
            if (response?.success) {
                state.brands.data = response.data.brands;
            } else {
                state.brands.error = response?.error;
            }
            state.brands.loading = false;
        });
        builder.addCase(loadBrands.rejected, (state, err) => {
            console.log(err);
            state.brands.loading = false;
        });

        //loadSalesStats
        builder.addCase(loadSalesStats.pending, (state) => {
            state.salesStats.loading = true;
        });
        builder.addCase(loadSalesStats.fulfilled, (state, action) => {
            const response = action.payload;
            if (response?.success) {
                state.salesStats.data = response.data.stats;
            } else {
                state.salesStats.error = response?.error;
            }
            state.salesStats.loading = false;
        });
        builder.addCase(loadSalesStats.rejected, (state, err) => {
            console.log(err);
            state.salesStats.loading = false;
        });

        //loadAccountPayableChart
        builder.addCase(loadAccountPayableChart.pending, (state) => {
            state.loadAccountPayableChart.loading = true;
        });
        builder.addCase(loadAccountPayableChart.fulfilled, (state, action) => {
            const response = action.payload;
            if (response?.success) {
                state.loadAccountPayableChart.data = response.data;
            } else {
                state.loadAccountPayableChart.error = response?.error;
            }
            state.loadAccountPayableChart.loading = false;
        });
        builder.addCase(loadAccountPayableChart.rejected, (state, err) => {
            console.log(err);
            state.loadAccountPayableChart.loading = false;
        });

        //loadBestSellers
        builder.addCase(loadBestSellers.pending, (state) => {
            state.bestSellers.loading = true;
        });
        builder.addCase(loadBestSellers.fulfilled, (state, action) => {
            const response = action.payload;
            if (response?.success) {
                state.bestSellers.data = response.data.best_sellers;
            } else {
                state.bestSellers.error = response?.error;
            }
            state.bestSellers.loading = false;
        });
        builder.addCase(loadBestSellers.rejected, (state, err) => {
            console.log(err);
            state.bestSellers.loading = false;
        });

        //loadCategories
        builder.addCase(loadCategories.pending, (state) => {
            state.categories.loading = true;
        });
        builder.addCase(loadCategories.fulfilled, (state, action) => {
            const response = action.payload;
            if (response?.success) {
                state.categories.data = response.data.categories;
            } else {
                state.categories.error = response?.error;
            }
            state.categories.loading = false;
        });
        builder.addCase(loadCategories.rejected, (state, err) => {
            console.log(err);
            state.categories.loading = false;
        });
    }
});

export default dashboard.reducer;

export const { setLoading, setStoreFilter, setSupplierFilter, reset } = dashboard.actions;
